import { action, ActionType } from "typesafe-actions";

import { ApprovalStatus } from "../../../types/approval-status/approval-status.type";

import { WorkOrderProductsActionType } from "../features/work-order-products/store/work-order-products.actions";
import { WorkOrderAssetsTabActionType } from "../features/work-order-assets-tab/store/work-order-assets-tab.actions";

export enum WorkOrderActions {
  UpdateStatus = "WorkOrder/UpdateStatus",
}

export const updateStatus = (status: ApprovalStatus) =>
  action(WorkOrderActions.UpdateStatus, status);

const actionCreators = {
  updateStatus,
};

export type WorkOrderActionType =
  | ActionType<typeof actionCreators>
  | WorkOrderProductsActionType
  | WorkOrderAssetsTabActionType;
